<template>
  <div>
    <div class="columns is-gapless is-vcentered is-border-bottom has-bg-light is-min-height-50">
      <div class="column is-padding-left">
        <span v-if="total" class="">{{total}} Programme<span v-if="total && total > 1">s</span></span>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <router-link :to="{name: 'AccessCreate', query: {promoteur: promoteur.pk}}"
                     class="button is-min-width-0 is-radiusless is-small is-light is-min-height-full has-text-grey">
          <span class="icon"><i class="fal fa-plus"></i></span>
          <span>Ajouter un mandat</span>
        </router-link>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <router-link :to="{name: 'ProgramCreate', query: {promoteur: promoteur.pk}}"
                     class="button is-min-width-0 is-radiusless is-small is-light is-min-height-full has-text-grey">
          <span class="icon"><i class="fal fa-plus"></i></span>
          <span>Ajouter un programme</span>
        </router-link>
      </div>
    </div>
    <spinner-round :isLoading="loading"></spinner-round>
    <table class="table is-hoverable is-fullwidth is-first-fixed-small is-last-fixed-small is-marginless-bottom" v-if="programs && programs.length">
      <thead>
      <tr class="is-size-6">
        <th></th>
        <th>Programme</th>
        <th>Statut</th>
        <th>Dispositif fiscaux</th>
        <th>Ville</th>
        <th>Nombre de lots</th>
        <th class="has-text-centered is-narrow">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="program in programs" :key="program.pk" class="is-size-6">
        <td class="has-text-centered">
          <router-link :to="{name: 'ProgramVue', params: {id: program.pk}}">
            <avatar :item="program"></avatar>
          </router-link>
        </td>
        <td>
            <span>
              <router-link :to="{name: 'ProgramVue', params: {id: program.pk}}">
                {{program.name | truncate}}
              </router-link>
            </span>
          <span class="icon has-text-warning tooltip is-tooltip-bottom"
                data-tooltip="Flux promoteur" v-if="program.from_flux">
              <i class="fas fa-rss-square"></i>
            </span>
          <span class="tag is-exclusif" v-if="program.is_exclusive">Exclusivité</span>
          <div class="tags" v-if="program.tags && program.tags.length > 0">
            <span v-for="t in program.tags" class="tag is-annonce is-rounded" :key="t">{{t}}</span>
          </div>
        </td>
        <td>
            <span class="tag is-small is-radius-xlarge has-text-white" :class="tagColor(program.status)">
              {{program.status|workflowLabel}}
            </span>
        </td>
        <td>
            <span v-for="(tax, index) in program.tax_dispositifs" v-if="index < 2" :key="index"
              class="is-wrap-normalX"
              style="word-wrap: anywhere; word-break: break-word;"
            >
              {{taxName(tax)}}<span>{{index === 0 && program.tax_dispositifs.length > 1 ? ', ' : index === 1 && program.tax_dispositifs.length > 1 ? '...' : ''}}</span>
            </span>
        </td>
        <td>{{program.address.city}} - {{program.address.zip_code}}</td>
        <td>{{program.lot_counts.total}}</td>
        <td class="has-text-centered actions">
          <display-button-list :buttons="buttonList" :data="program"></display-button-list>
        </td>
      </tr>
      <tr v-if="hasMore">
        <td width="33%"></td>
        <td width="33%">
          <infinite-loading spinner="waveDots" @infinite="infiniteHandler"></infinite-loading>
        </td>
        <td width="33%"></td>
      </tr>
      </tbody>
    </table>
    <div v-if="(!programs || !programs.length) && !loading">
      <div class="column">
        Pas de programme pour ce promoteur.
      </div>
    </div>
  </div>
</template>

<script>
  import { DefaultValues } from '@/mixins'

  export default {
    name: 'PromoteurProgramPanel',
    mixins: [DefaultValues],
    props: {
      programs: {
        type: Array,
        required: true
      },
      total: {
        type: Number,
        required: false
      },
      promoteur: {
        type: Object,
        required: true
      },
      hasMore: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        buttonList: [
          {
            routeName: 'ProgramVue',
            icon: 'fa-eye',
            text: 'Voir'
          }
        ],
        infiniteLoaderEnabled: true
      }
    },
    methods: {
      infiniteHandler ($state) {
        this.$emit('loadMore', $state)
      },
      taxName (value) {
        if (!value) return ''
        value = value.toString().split('_').join(' ')
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      tagColor (value) {
        const COLORS = {
          'private': 'is-private',
          'available': 'is-disponible',
          'draft': 'is-draft',
          'archived': 'is-draft'
        }
        return COLORS[value]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/promoteur/PromoteurProgramPanel.vue